
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ContractorChip from "@/components/companyProjects/ContractorChip.vue";
  import ItemChip from "@/components/common/ItemChip.vue"
  import RouteNames from "@/entities/RouteNames";

  import ContractorChipData from "@/entities/ContractorChipData";
  import EmployeeRemovedFromCompanyTooltip from "@/components/tooltip/EmployeeRemovedFromCompanyTooltip.vue";

  @Component({
    components: {
      EmployeeRemovedFromCompanyTooltip,
      ContractorChip,
      ItemChip,
    },
  })
  export default class ContractorChips extends Vue {
    @Prop({required: true,  type: Array}) readonly contractors!: ContractorChipData[];
    @Prop({default: 3, type: Number}) readonly limit!: number;
    @Prop({default: undefined, type: Object}) readonly navigateTo!: object;

    routeNames = RouteNames;

    get noContent(): boolean {
      return !this.contractors.length;
    }

    get contractorsToRender(): ContractorChipData[] {
      return this.contractors.slice(0, this.limit);
    }

    get contractorsMoreThanLimit(): boolean {
      return this.contractors.length > this.limit;
    }

    get alignmentClass(): string {
      return this.noContent ? "items-end mt-0.5" : "items-center";
    }

    getContractorRoute(route: RouteNames | undefined = undefined) {
      if (route) {
        return route;
      }
      return RouteNames.CONTRACTOR_DETAILS_ABOUT;
    }

    isActivityExist(activityCount: number): boolean {
      return activityCount > 0;
    }
  }
